import { render, staticRenderFns } from "./OrderPrintBlank.vue?vue&type=template&id=a10c5cbe&"
import script from "./OrderPrintBlank.vue?vue&type=script&lang=js&"
export * from "./OrderPrintBlank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports